//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientGraphQLAuthMutation, clientQuery } from 'Core/data/GraphQLApi';
import { clientPOST } from 'Core/data/RestApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    FORGOT_PASSWORD_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    forgotPasswordResult
} from 'Redux/actions';

function* forgotPasswordRequest({ payload }) {
    let result = null;
    try {
        const { username, code, password, navigate } = payload;
        let data = yield call(
            clientGraphQLAuthMutation,
            `
               mutation (
                    $confirmationCode: String!
                    $password: String!
                    $username: String!
                ){
                    result: confirmForgotPassword (
                        username: $username
                        confirmationCode: $confirmationCode
                        password: $password
                    ) 
                }
            `,
            {
                username,
                confirmationCode: code,
                password
            }
        );
        result = {
            success: data.result
        }

        yield put(forgotPasswordResult(result, null));

    } catch (exc) {
        ExceptionManager(exc, 'Core/views/forgotPassword/redux', 'forgotPasswordRequest')
        result = { success: false, message: exc.message }
        yield put(forgotPasswordResult(result, exc));
    }
}



function* watchLoginRequests() {
    yield takeEvery(FORGOT_PASSWORD_REQUEST, forgotPasswordRequest);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchLoginRequests)
    ]);
}